export default "__VITE_ASSET__Bi0Du6V3__"